import * as React from "react"
import { Row, Col } from "shards-react"

const ContactTray = props => (
  <Row className="mt-3">
    <Col xs={6}>
      <i class="fa-solid fa-phone mr-2 fa-xl text-success"></i>
      {props.phone_one}
    </Col>
    <Col xs={6}>
      <i class="fa-solid fa-envelope mr-2 fa-xl text-secondary"></i>
      <a href={"mailto:" + props.email}>{props.email}</a>
    </Col>
  </Row>
)

export default ContactTray
